function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Platform, Switch } from "react-native";
//import CheckBox from "@react-native-community/checkbox";

export default class CustomCheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: this.props.isChecked
    };
  }
  render() {
    const {
      testID
    } = this.props;
    if (Platform.OS === 'ios') {
      return /*#__PURE__*/React.createElement(Switch, {
        testID: testID
        // eslint-disable-next-line react-native/no-inline-styles
        ,
        style: {
          marginRight: 5,
          marginLeft: 5
        },
        value: this.state.isChecked,
        onValueChange: value => this.handleValueChange(value)
      });
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null)
      // <CheckBox
      //   testID={testID}
      //   // eslint-disable-next-line react-native/no-inline-styles
      //   style={{
      //     marginRight: Platform.OS === "web" ? 5 : 0,
      //     marginLeft: Platform.OS === "web" ? 5 : 0 }}
      //   value={this.state.isChecked}
      //   onValueChange={value => this.handleValueChange(value)}
      // />
      ;
    }
  }
  componentWillReceiveProps(nextProps) {
    if (true) {
      this.setState({
        isChecked: nextProps.isChecked
      });
    }
  }
  handleValueChange(value) {
    this.setState({
      isChecked: value
    });
    if (this.props.onChangeValue) {
      this.props.onChangeValue(value);
    }
  }
}
_defineProperty(CustomCheckBox, "propTypes", {
  testID: PropTypes.string,
  isChecked: PropTypes.bool.isRequired,
  onChangeValue: PropTypes.func.isRequired
});